// extracted by mini-css-extract-plugin
export default {"main":"InvoicingConfig_main__24a8l","settingsContainer":"InvoicingConfig_settingsContainer__jOr9k"};